import React, { useEffect } from "react";
import "./swadaaExpress.css";
import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/footer/Footer";
import { useNavigate } from "react-router-dom";
import { director_image } from "../../assets";
import { useLocation } from "react-router-dom";
import GetStartedSection from "../../components/getStartedSection/GetStartedSection";
import SEO from "../../components/SEO/SEO";

const SwadaaExpress = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  const navigate = useNavigate();
  return (
    <div>
      <SEO
        title="Swadaa Express"
        description="Swadaa Express coordinates community outreach, awareness campaigns, and empowerment programs that support safer neighborhoods and stronger families through education and youth development."
        keywords="Swadaa Express, community outreach, awareness campaigns, youth empowerment, women empowerment, community development, safety education"
      />
      <Navbar />
      <div className="homeAbout_sectionOneCont">
        <div className="homeAbout_sectionOne_gen">
          <div className="homeAbout_startedHeader">
            Swadaa <span className="homeAbout_startedSub">Express</span>{" "}
          </div>

          <div className="homeAbout_paraGen">
            <div>
              <div className="homeAbout_director_image">
                <div className="homeAbout_director_image____">
                  <img src={director_image} />
                </div>
              </div>
              <div className="homeAbout_director_name">
                Com. Chijioke Ugochukwu
              </div>
              <div className="homeAbout_director_title">Director General</div>
            </div>

            <div className="homeAbout_para">
              SWADAA NGO is committed to eradicating drug abuse in Nigeria.
              Through partnerships, training programs, and awareness campaigns,
              we aim to prevent drug abuse and its negative impacts in the
              society. SWADAA's focus on education and rehabilitation aligns
              with NDLEA's efforts to create a drug-free environment. Together,
              we strive to address the root causes of drug abuse and provide
              support for individuals recovering from addiction.
              <div style={{ marginTop: "10px" }}>
                SWADAA is a non-profit organization approved by the Nigerian
                government and partnered with NDLEA. Our mission is to raise
                awareness about drug abuse and promote healthy lifestyles among
                youths. Through educational initiatives, outreach programs, and
                collaborations with government agencies and security forces,
                SWADAA works tirelessly to combat drug abuse in schools,
                universities, communities, and various social gatherings. Our
                goal is to empower individuals to say no to drugs and embrace a
                life free from substance abuse, ultimately contributing to a
                safer and healthier society.
              </div>
            </div>
          </div>

          {/* <a
          href="https://api.whatsapp.com/send?phone=+2348033477608&text=I%20am%20reaching%20out%20to%20explore%20your%20business%20offering."
          target="_blank"
          className="getStarted_btn"
          style={{ textDecoration: "none" }}
        >
          Lets Get Started
        </a> */}

          <GetStartedSection />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SwadaaExpress;
